import { formatMskDateTime } from '../../matching/routes/Dashboard/core/mskTime'

/**
 * Момент освобождения чанка принадлежит спору, а не матчу, и его пустота значит разное: спора нет
 * вовсе либо выплата держится бессрочно. Оба состояния приходили `null` и рисовались одинаковым
 * «—», так что по карточке нельзя было понять, удерживается выплата или нет.
 *
 * То же правило, по которому бэкенд считает доступность освобождения: держит только открытый спор.
 */
export const holdLabel = (disputeStatus: string | null, heldUntil: string | null): string => {
  if (disputeStatus === null) return 'спора нет'
  if (disputeStatus !== 'OPEN') return 'спор закрыт, не удерживается'

  return heldUntil === null ? 'держим бессрочно' : formatMskDateTime(heldUntil)
}
